export const GROUPS = {
    MANAGEMENT: 'Dirección',
    ADMINISTRATION: 'Administración y finanzas',
    OPERATIVO: 'Operativo',
    ADMIN: 'Administrador',
    AGENTS: 'Agentes de cuenta',
    MARKETING: 'Administrador Marketing',
    CONTRACTOR: 'Contratante',
    PROVIDER: 'Proveedores',
    LOGISTIC: 'Logística',
    QUALITY: 'Calidad',
    COUPA: 'Coupa'
};
